module.exports = __webpack_public_path__ + "static/media/Discord.cb377620.svg";